import { useMutation } from "@apollo/client";
import React, { useRef, useState } from 'react';
import * as short from "short-uuid";
import styles from "./AddOrganisationForm.module.scss";
import { CREATE_ORGANISATION, ORGANISATIONS, ORGANISATIONS_LIST, TAG_SUGGESTIONS } from '../../apollo/queries';
import { FormikProps } from 'formik';

import { UserFormData } from '../../apollo/types/UserFormData';
import { AddUserForm } from '../AddUserForm';
import { OrganisationData } from '../../apollo/types/OrganisationData';
import { OrganisationDataPlusUrl, OrganisationForm } from '../OrganisationForm';
import { client } from '../../apollo/client';
import { FileUpload } from '../common/FileUpload';
import { AssessmentOptionsForm } from '../AssessmentOptionsForm';
import { AssessmentOptions } from '../../apollo/types/AssessmentOptions';


export const AddOrganisationForm = () => {
  const formikRef = useRef<FormikProps<OrganisationDataPlusUrl>>(null);
  const formikRefUserForm = useRef<FormikProps<UserFormData>>(null);
  const formikRefAssessmentOptionsForm = useRef<FormikProps<AssessmentOptions>>(null);
  const [sendingSuccessful, setSendingSuccessful] = useState(false);
  const [errorFound, setErrorFound] = useState(false);
  const [userPassword, setUserPassword] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const initialFormValues = {
    venture: "",
    address: "",
    city: "",
    sector: "",
    contactPerson: '',
    website: '',
    institutionUuid: short.generate(),
    parentId:  0,
    urlPrefix: ''
  };

  const initialUserFormValues = {
    name: "",
    emailAddress: "",
    userFunction: "",
    language: "nl",
  }

  const initialAssessmentOptionsValues = {
        assessmentTitle: "",
        assessmentColorPrimary: "",
        assessmentColorSecondary: "",
        assessmentEmailFromName: "",
        assessmentEmailFromAddress: "",
        assessmentResultToName: "",
        assessmentResultToAddress: "",
        assessmentCopyright: "",
        assessmentSignature: "",
        assessmentAskQuestionsTo: "",
        assessmentAskQuestionsLink: "",
        assessmentLogo: "",
        sendStartMail: true
  }


  const [formData, setFormData] = useState<OrganisationDataPlusUrl>(initialFormValues)
  const [userFormData, setUserFormData] = useState<UserFormData>(initialUserFormValues)
  const [
      assessmentOptionsFormData,
      setAssessmentOptionsFormData
  ] = useState<AssessmentOptions>(initialAssessmentOptionsValues)
  const [logoUrl, setLogoUrl] = useState<string|null>(null)

  let userData: UserFormData = initialUserFormValues;
  const setUserData = (values: UserFormData) => {
    userData = values;
    setUserFormData(values)
  }
    let assessmentOptionsData: AssessmentOptions = initialAssessmentOptionsValues;
    const setAssessmentOptionsData = (values: AssessmentOptions) => {
        assessmentOptionsData = values;
        setAssessmentOptionsFormData(values)
    }

  const [createOrganisationAction] = useMutation(CREATE_ORGANISATION, {
    onCompleted: (data) => {
      if(data !== null && data.addAdminOrganisation && data.addAdminOrganisation.code === 200) {
        setSendingSuccessful(true)
        setErrorFound(false)
        setUserPassword(data.addAdminOrganisation.userPassword)
      } else {
        setSendingSuccessful(false)
        setErrorFound(true)
        setErrorMessage(data.errors[0].message)
      }
      client.refetchQueries({
        include: [ORGANISATIONS_LIST, ORGANISATIONS]
      })
    },
    onError: (errors) => {
      setErrorFound(true)
      setSendingSuccessful(false)
      // @ts-ignore
      setErrorMessage(errors.message)
    }
  });

  const submitForm = (values: OrganisationDataPlusUrl) => {
      if(logoUrl) {
        values.logoUrl = logoUrl
      }

      createOrganisationAction({
        variables: {
          input: {
            ...values,
            ...userData,
            ... {
                assessmentOptions: assessmentOptionsData
            }
          }
        }
      })
  }

  return (
    <div className={styles.wrapper}>
          <OrganisationForm formikRef={formikRef} submitValues={(values: OrganisationDataPlusUrl) => {
             submitForm(values)
          }} formData={formData}/>

          <header className={styles.header}>Organisation Logo</header>
          <FileUpload valueChanged={(value: string) => {
              setLogoUrl(value)
          }}></FileUpload>
          {logoUrl &&
              <div className={styles.logoBlock}>
                <img src={logoUrl}></img>
              </div>
          }
          <br/>

          <header className={styles.header}>Contact User</header>
          <AddUserForm formikRef={formikRefUserForm} formData={userFormData} submitValues={(values: UserFormData) => {
              setUserData(values)
          }}></AddUserForm>

          <header className={styles.header}>Assessment Options</header>
          <AssessmentOptionsForm formikRef={formikRefAssessmentOptionsForm} formData={assessmentOptionsFormData} submitValues={(values: AssessmentOptions) => {
              setAssessmentOptionsData(values)
          }}></AssessmentOptionsForm>

          <button
              className={styles.send}
              type='button'
              onClick={() => {
                    formikRefUserForm.current?.submitForm()
                    formikRefAssessmentOptionsForm.current?.submitForm()
                    formikRef.current?.submitForm()
              }}
              // disabled={sendingSuccessful || errorFound}
          >{`Create`}</button>
          {sendingSuccessful && (
              <span className={styles.sendSuccessful}>Organisation created successful, password for user: {userPassword}</span>
          )}
          {errorFound && (
              <span className={styles.sendFailed}>Oops, something went wrong with creating organisation: `{errorMessage}`</span>
          )}
    </div>
  );
};
